import _map from 'lodash/map';

export const getDropdownOptions = Data => _map(Data, data => ({
  value: data,
  label: data,
}));
